import type { knowledgeBaseDocuments, knowledgeBaseFolders } from '@/drizzle/schema'

export type KnowledgeBaseFolder = typeof knowledgeBaseFolders.$inferSelect
export type KnowledgeBaseFolderSourceType = KnowledgeBaseFolder['sourceType']
export type KnowledgeBaseDocument = typeof knowledgeBaseDocuments.$inferSelect
export type KnowledgeBaseDocumentSourceType = KnowledgeBaseDocument['sourceType']

export const KNOWLEDGE_BASE_FOLDER_SOURCE_TYPE_WEBSITE = 'website' satisfies NonNullable<KnowledgeBaseFolderSourceType>
export const KNOWLEDGE_BASE_DOCUMENT_SOURCE_TYPE_WEBSITE = 'website' satisfies NonNullable<KnowledgeBaseDocumentSourceType>
export const KNOWLEDGE_BASE_DOCUMENT_SOURCE_TYPE_INSTAGRAM = 'instagram' satisfies NonNullable<KnowledgeBaseDocumentSourceType>
export const KNOWLEDGE_BASE_DOCUMENT_SOURCE_TYPE_FACEBOOK = 'facebook' satisfies NonNullable<KnowledgeBaseDocumentSourceType>
/** What an agent learned from its conversations: the tenant's one learned folder and the documents in it. */
export const KNOWLEDGE_BASE_SOURCE_TYPE_LEARNED = 'learned' satisfies NonNullable<KnowledgeBaseFolderSourceType> &
  NonNullable<KnowledgeBaseDocumentSourceType>
export const LEARNED_FOLDER_NAME = 'Learned from conversations'

export function isLearnedSource(sourceType: string | null | undefined): boolean {
  return sourceType === KNOWLEDGE_BASE_SOURCE_TYPE_LEARNED
}

/** Why a change to what the platform learned is refused: its folder and documents are the platform's. */
export const LEARNED_REFUSALS = {
  add: `Only the platform adds documents to ${LEARNED_FOLDER_NAME}.`,
  change: 'A learned document stays in its folder, searchable only, and is never a default for all agents.',
  share: 'A learned document belongs to the agent that learned it.',
  deleteFolder: `${LEARNED_FOLDER_NAME} stays. Delete its documents one by one instead.`,
} as const

export function getSocialKnowledgeBaseDocumentSourceType(
  platform: 'instagram' | 'facebook',
): 'instagram' | 'facebook' {
  switch (platform) {
    case 'instagram':
      return KNOWLEDGE_BASE_DOCUMENT_SOURCE_TYPE_INSTAGRAM
    case 'facebook':
      return KNOWLEDGE_BASE_DOCUMENT_SOURCE_TYPE_FACEBOOK
    default: {
      const exhaustivePlatform: never = platform
      return exhaustivePlatform
    }
  }
}
